import { Component } from '@angular/core';
import { ProductSearchPage } from '@spartacus/core';
import { PageLayoutService, ProductListComponentService } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'cx-plp-no-content',
  templateUrl: './plp-no-content.component.html',
  styleUrl: './plp-no-content.component.scss',
  standalone: false,
})
export class PlpNoContentComponent {
  subscription = new Subscription();
  page$ = this.pageLayoutService.page$;
  productList$ = new BehaviorSubject('');
  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;
  hasProduct$ = new BehaviorSubject(true);
  isLoading$ = new BehaviorSubject(true);

  constructor(
    private pageLayoutService: PageLayoutService,
    private productListComponentService: ProductListComponentService,
  ) {}

  ngOnInit(): void {
    this.checkProducts();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkProducts() {
    this.subscription.add(
      this.model$.subscribe((data: ProductSearchPage) => {
        this.isLoading$.next(data.products === undefined);
        this.hasProduct$.next(data.products !== undefined && data.products.length > 0);
      }),
    );
  }
}
